export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["Inbound"] = "Inbound";
    MessageDirection["Outbound"] = "Outbound";
})(MessageDirection || (MessageDirection = {}));
export var WritingIssueType;
(function (WritingIssueType) {
    WritingIssueType["Spelling"] = "SPELLING";
    WritingIssueType["Grammar"] = "GRAMMAR";
})(WritingIssueType || (WritingIssueType = {}));
export var InteractionMessageType;
(function (InteractionMessageType) {
    InteractionMessageType["Standard"] = "Standard";
    InteractionMessageType["System"] = "System";
})(InteractionMessageType || (InteractionMessageType = {}));
//# sourceMappingURL=messages.js.map